module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Antal öl per bryggeri")]), _vm._v(" "), _c('table', {
    staticClass: "table is-narrow is-fullwidth"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.orderBy(_vm.beerData, ['count', 'brewery'], ['desc', 'asc']).slice(0, _vm.breweriesInList)), function(data, index) {
    return [_c('tr', {
      key: index,
      staticClass: "brewery",
      attrs: {
        "data-key": data.brewery_id
      },
      on: {
        "click": function($event) {
          _vm.toggle($event, data.brewery_id)
        }
      }
    }, [_c('td', [_c('i', {
      staticClass: "expander",
      attrs: {
        "id": ['expander__' + data.brewery_id]
      }
    }), _vm._v(_vm._s(data.brewery))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered total-beers__count"
    }, [_vm._v(_vm._s(data.count))])]), _vm._v(" "), _c('tr', {
      key: 'row-' + index,
      staticClass: "brewery__beers",
      attrs: {
        "id": data.brewery_id
      }
    }, [_c('td', {
      staticClass: "beers-data",
      attrs: {
        "colspan": "2"
      }
    }, [_c('table', {
      staticClass: "table is-striped is-fullwidth"
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', _vm._l((_vm.orderBy(data.data, 'average', 'desc')), function(beer, bIndex) {
      return _c('tr', {
        key: bIndex
      }, [_c('td', [_c('v-link', {
        attrs: {
          "query": beer.name,
          "showTitle": "true"
        }
      })], 1), _vm._v(" "), _c('td', {
        staticClass: "has-text-centered"
      }, [_vm._v(_vm._s(beer.average))])])
    }))])])])]
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "has-text-right is-size-7 is-uppercase",
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    on: {
      "click": _vm.toogleBeersInList
    }
  }, [_vm._v(_vm._s(_vm.breweriesInListButtonText))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Bryggeri")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered"
  }, [_vm._v("Antal öl")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "beers-data__header"
  }, [_c('th', [_vm._v("Namn")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Snitt")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2432bc54", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2432bc54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/facts/TopBreweries.vue
// module id = 150
// module chunks = 1